if (!customElements.get("product-form-switcher")) {
  customElements.define(
    "product-form-switcher",
    class ProductFormSwitcher extends HTMLElement {
      constructor() {
        super();

        this.settings = {
          bulk: "bulk",
          classic: "classic",
          bulkButtonAlternativeName: "multi",
          emptyBoxes: "At least one quantity must be greater than 0",
          switcher: (form) => `Use ${form} Selector`,
        };

        this.activeForm =
          localStorage.getItem("product_form_selector") || this.settings.bulk;

        this.switcherButton = this.querySelector(
          ".product-form-switcher-element"
        );

        this.productForms = [...this.querySelectorAll("[data-form-selector]")];

        this.bulkQuantityBoxes = this.querySelectorAll(
          ".product-form__qty-bulk"
        );

        this.bulkdAddToCartButton = this.querySelector(
          "[data-action='bulk-add-to-cart']"
        );

        this.bulkCartErrors = this.querySelector(".bulk-add-to-cart-errors");
      }

      connectedCallback() {
        this.updateUI();

        this.switcherButton.addEventListener(
          "click",
          this.toggleForm.bind(this)
        );

        this.bulkQuantityBoxes.forEach((box) => {
          box.addEventListener(
            "keydown",
            this.handleQuantityBoxKeybardEvents.bind(this)
          );
          box.addEventListener(
            "click",
            this.handleQuantityBoxClickEvent.bind(this)
          );
          box.addEventListener(
            "blur",
            this.handleQuantityBoxBlurEvent.bind(this)
          );
        });

        this.bulkdAddToCartButton.addEventListener(
          "click",
          this.handleSubmittinBulkForm.bind(this)
        );
      }

      handleSubmittinBulkForm(event) {
        event.preventDefault();

        const cartItems = [];

        this.bulkQuantityBoxes.forEach((box) => {
          if (box.value > 0) {
            const variantId = box.getAttribute("data-variant-id");
            const maximumQuantity = parseInt(box.getAttribute("max"));
            const variantQuantity = parseInt(box.value);

            let cartQuantity = variantQuantity;

            if (cartQuantity > maximumQuantity) {
              cartQuantity = maximumQuantity;
            }

            cartItems.push({
              id: variantId,
              quantity: cartQuantity,
            });
          }
        });

        this.bulkCartErrors.textContent = "";

        if (cartItems.length) {
          this.addItemsToCart(cartItems);
        } else {
          this.bulkCartErrors.textContent = this.settings.emptyBoxes;
        }
      }

      handleQuantityBoxKeybardEvents(event) {
        if (event.code === "Enter" || event.keyCode === 13) {
          event.preventDefault();
        }
      }

      handleQuantityBoxClickEvent(event) {
        const boxQuantityValue = +event.target.value;

        if (boxQuantityValue === 0) {
          event.target.value = "";
        }
      }

      handleQuantityBoxBlurEvent(event) {
        const boxQuantityValue = event.target.value;

        if (boxQuantityValue === "" || parseInt(boxQuantityValue) <= 0) {
          event.target.value = 0;
        }
      }

      async addItemsToCart(items) {
        this.bulkdAddToCartButton.setAttribute("disabled", true);

        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: JSON.stringify({ items: items }),
          headers: { "Content-type": "application/json" },
          credentials: "include",
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.message) {
              this.bulkCartErrors.textContent = response.message;

              setTimeout(() => {
                this.bulkCartErrors.textContent = "";
              }, 4000);

              console.log(response);
              return;
            }

            let quantity = 0;
            items.forEach((item) => (quantity += item.quantity));

            document.documentElement.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  quantity,
                },
              })
            );

            this.bulkQuantityBoxes.forEach((box) => (box.value = 0));
            this.bulkdAddToCartButton.removeAttribute("disabled");
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      toggleForm(event) {
        event.preventDefault();
        this.activeForm = this.getOppositeForm();
        localStorage.setItem("product_form_selector", this.activeForm);
        this.updateUI();
      }

      updateUI() {
        const oppositeForm = this.getOppositeForm();
        const buttonName =
          oppositeForm === this.settings.bulk
            ? this.settings.bulkButtonAlternativeName
            : oppositeForm;

        this.switcherButton.textContent = this.settings.switcher(buttonName);
        this.productForms.forEach((form) =>
          form.toggleAttribute(
            "hidden",
            form.dataset.formSelector !== this.activeForm
          )
        );
      }

      getOppositeForm() {
        return this.activeForm === this.settings.bulk
          ? this.settings.classic
          : this.settings.bulk;
      }
    }
  );
}
